import { render, staticRenderFns } from "./terms-end.vue?vue&type=template&id=51ab5d66&"
import script from "./terms-end.vue?vue&type=script&lang=js&"
export * from "./terms-end.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports